<div>
    <div class="select-ddl col-33 padding-5">
        <!-- <div>Sample Listing</div> -->
        <mat-form-field class="width-full">
          <mat-select [(ngModel)]="selected_category" (ngModelChange)="onFilterNutritionCategory()">
            <mat-option [value]="default_value">View Category layout</mat-option>
            <mat-option *ngFor="let data of exerciseCategories"  [value]="data.id">{{data.name}}</mat-option>
          </mat-select>
        </mat-form-field>
    </div>
    <div>
        <table mat-table [dataSource]="datasource" class="mat-elevation-z10" multiTemplateDataRows>
            <ng-container matColumnDef="name">
                <th class="fieldlbls" mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> 
                    <div class="namefld">
                        {{element.name}}
                    </div> 
                </td>
            </ng-container>
            <ng-container matColumnDef="parentcategory">
                <th class="fieldlbls" mat-header-cell *matHeaderCellDef> Parent Category </th>
                <td mat-cell *matCellDef="let element; let i = dataIndex"> 
                    <div class="select-ddl">
                        <mat-form-field class="width-full">
                            <mat-label>No Parent Category</mat-label>
                          <mat-select [(ngModel)]="element.parent_id" (ngModelChange)="onChangeExerciseCategory(i)">
                            <mat-option>No Parent Category</mat-option>
                            <mat-option *ngFor="let data of exerciseCategories"  [value]="data.id">{{data.name}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                    </div> 
                </td>
            </ng-container>
            <ng-container matColumnDef="exerciseplantemplates">
                <th class="fieldlbls" mat-header-cell *matHeaderCellDef> Exercise templates </th>
                <td mat-cell *matCellDef="let element"> 
                    <div class="client-name">
                        <div class="label-primary" *ngFor="let obj of element.exerciseplantemplates">
                            {{obj.name}}
                        </div>
                    </div> 
                </td>
            </ng-container>
            <ng-container matColumnDef="delete">
                <th class="fieldlbls" mat-header-cell *matHeaderCellDef> Delete </th>
                <td mat-cell *matCellDef="let element; let i = dataIndex"> 
                    <div class="delete-field">
                        <mat-icon (click)="deleteHandle(element.id, i)">delete_outline</mat-icon>
                    </div> 
                </td>
            </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="example-detail-row"></tr>
    </table>
    </div>
</div>